export const detailTitle = state => state.detailTitle
export const moblie = state => state.moblie
export const sid = state => state.sid
export const searchText = state => state.searchText
export const DepsDat = state => state.DepsDat
export const clickCid = state => state.clickCid